/**
 * A distance in metres, written the way a person says it: `850 m` up to a
 * kilometre, then kilometres with one place where there is one (`3,2 km`,
 * `4 km`), and whole kilometres from a hundred on.
 */
import type { Language } from "@/shared/i18n/languages";

import { formatDecimal, groupThousands, NBSP } from "./money";

const UNITS: Readonly<Record<Language, { m: string; km: string }>> = {
  uz: { m: "m", km: "km" },
  ru: { m: "м", km: "км" },
  en: { m: "m", km: "km" },
};

export function formatDistance(metres: number, language: Language): string {
  const units = UNITS[language];
  const whole = Math.max(0, Math.round(metres));
  if (whole < 1000) return `${String(whole)}${NBSP}${units.m}`;
  const km = whole / 1000;
  if (km >= 100) return `${groupThousands(String(Math.round(km)))}${NBSP}${units.km}`;
  const tenths = Math.round(km * 10) / 10;
  const written = Number.isInteger(tenths) ? String(tenths) : formatDecimal(tenths, language, 1);
  return `${written}${NBSP}${units.km}`;
}
